import store from 'store';

import axios from '@common/backend/axios';

type RuntimeEnv = Record<string, string | undefined>;

const runtimeEnv = ((window as typeof window & { __ENV__?: RuntimeEnv }).__ENV__ ??
	{}) as RuntimeEnv;

const getEnvRaw = (key: string): string | undefined => {
	const runtimeValue = runtimeEnv[key];
	const runtimeIsPlaceholder = typeof runtimeValue === 'string' && /^__.+__$/.test(runtimeValue);
	const buildValue = (import.meta as any).env?.[key];
	if (!runtimeIsPlaceholder && typeof runtimeValue === 'string') return runtimeValue;
	return typeof buildValue === 'string' ? buildValue : undefined;
};

const sanitize = (value?: string) => {
	if (!value) return undefined;
	return value.trim().replace(/^['"]+|['"]+$/g, '');
};

export const env = {
	clientApiUrl: sanitize(getEnvRaw('ENV_CLIENT_API_URL')),
	sentryDsn: sanitize(getEnvRaw('ENV_SENTRY_DSN')),
	sentryTracesSampleRate: sanitize(getEnvRaw('ENV_SENTRY_TRACES_SAMPLE_RATE')),
	app: sanitize(getEnvRaw('ENV_APP')),
	isDev: sanitize(getEnvRaw('IS_DEV')),
	streamApiKey: sanitize(getEnvRaw('ENV_STREAM_API_KEY')),
	runtimeInjected: Boolean(runtimeEnv && Object.keys(runtimeEnv).length),
};

const ensureProcessEnv = () => {
	if (!env.runtimeInjected) return;
	(window as any).process = (window as any).process || {};
	(window as any).process.env = {
		...(window as any).process.env,
		...runtimeEnv,
		...(env.streamApiKey ? { ENV_STREAM_API_KEY: env.streamApiKey } : {}),
	};
};

const applyClientConfig = () => {
	if (env.clientApiUrl) {
		axios.defaults.baseURL = env.clientApiUrl;
	}
	store.addStreamKey?.(env.streamApiKey);
	store.addAppEnvironment?.(env.app);
};

export const initEnv = () => {
	ensureProcessEnv();
	applyClientConfig();
};
